import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../seo.css';
import '../Service/scervice.scss';
import img from './../../../assets/Img';
import ServicesSlider from './../ServicesSlider';
import SEOandPPC from "./SEOandPPC";
import SocialMediaSection from './SocialMediaSection';
import WhyChooseRightClick from './../branding/WhyChooseRightClick';
import Component from '../../../constants/Component';
const translations = {
  en: require('../../../Translate/en.json').DigitalMarketing,
  ar: require('../../../Translate/ar.json').DigitalMarketing,
};
const Marketing = () => {
  const { i18n } = useTranslation();
    const isLang = i18n.language;
  const t = translations[isLang || 'en'];

  const data = {
    title: t.title,
    dec: t.dec,
    img: img.DigitalMarketingSlider,
    title2: t.title2,
    dec2: t.dec2,
  };
   useEffect(() => { 
      window.scroll(0, 0)  
    }, [])
  

  return (
    <div>
      <div className="overflow-hidden">
        <ServicesSlider t={t} data={data} />
        <div className="horizontal-process-container">
          <div className="horizontal-process-card">
            <div className="horizontal-process-content">
              <h2 className="horizontal-process-title"> {t.Process} </h2>
              <p className="horizontal-process-description"> {t.Processd}   </p>
            </div>
          </div>
        </div>

        <SEOandPPC />
        <SocialMediaSection />
        <WhyChooseRightClick />
        <Component.ContactUSHome />
      </div>

    </div>
  )
}

export default Marketing
